const joinClasses = (...classes) => classes.flat().join(" ");

// Set CSS custom property for viewport height that works on mobile browsers
const setViewportHeight = () => {
  // Get the viewport height and multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  // Set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export { joinClasses, setViewportHeight };
